import React from 'react';
import { 
  Box, 
  Flex, 
  Heading, 
  Text, 
  Center,
  VStack,
  Icon,
  Button
} from '@chakra-ui/react';
import { FaTools } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const CustomeAsset = () => {
  const navigate = useNavigate();
  
  return (
    <Flex 
      width="100%" 
      height="100%" 
      minH="80vh" 
      direction="column" 
      align="center" 
      justify="center"
      bg="white"
      p={8}
    >
      <Center>
        <VStack spacing={6} textAlign="center" maxW="600px">
          <Icon as={FaTools} boxSize={16} color="blue.500" />
          
          <Heading size="xl" color="gray.800">
            Custom Assets
          </Heading>
          
          <Text fontSize="lg" color="gray.600">
            We've got exciting features coming soon!
          </Text>
          
          <Box h={4} />
          
          <Button 
            colorScheme="blue" 
            size="md"
            onClick={() => navigate('/')}
          >
            Return to Dashboard
          </Button>
        </VStack>
      </Center>
    </Flex>
  );
};

export default CustomeAsset;